import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

function TimerIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 50 50" {...props}>
      <path d="M 24 0 L 24 1 L 24 10 A 1.0001 1.0001 0 1 0 26 10 L 26 2.09375 C 38.238868 2.6287139 48 12.628751 48 25 C 48 37.715666 37.715666 48 25 48 C 12.284334 48 2 37.715666 2 25 C 2 18.646129 4.5603351 12.913208 8.71875 8.75 A 1.0001 1.0001 0 1 0 7.3125 7.34375 C 2.7949149 11.866542 0 18.105871 0 25 C 0 38.796334 11.203666 50 25 50 C 38.796334 50 50 38.796334 50 25 C 50 11.204625 38.796384 0 25 0 L 24 0 z M 12.46875 12.46875 C 12.46875 12.46875 21.703 25.953 22.875 27.125 C 24.047 28.297 25.954 28.296 27.125 27.125 C 28.297 25.954 28.297 24.047 27.125 22.875 C 25.953 21.703 12.46875 12.46875 12.46875 12.46875 z" />
    </SvgIcon>
  );
}

export default TimerIcon;
